import React, { FC, useState, useEffect, memo } from "../../../lib/teact/teact";
import Button from "../../ui/Button";
import ListItem from "../../ui/ListItem";
import { AdminApi } from "../restapi/adminApi";
import { GetUserID } from "../utils/common";
import { User } from "./AdminTypes";
import UserItem from "./userItem";
type OwnProps = {
    dataFilter: string;
    onChangeScreen: (data: any) => void;
}
type State = {
    usersList: User[]

    stackUserId: string[],
    stackUserName: string[],
    curUserId: string,
}
const AgentListEx: FC<OwnProps> = ({
    dataFilter,
    onChangeScreen
}) => {
    const curUserId = GetUserID()
    const [state, setState] = useState<State>({
        usersList: [],

        stackUserId: [curUserId],
        stackUserName: [],
        curUserId: curUserId
    })
    useEffect(() => {
        const userId = state.stackUserId[state.stackUserId.length - 1]
        AdminApi.GetDirectChilren({ userId: userId }).then(res => {
            setState(prev => ({ ...prev, usersList: res.data }))
        })
    }, [state.stackUserId])
    function addUserToStack(user: User) {
        setState(prev => ({
            ...prev, stackUserId: [...prev.stackUserId, user.userId.toString()],
            stackUserName: [...prev.stackUserName, user.username],
            curUserId: user.userId.toString()
        }))
    }
    function removeUserFromStack() {
        if (state.stackUserId.length > 1)
            setState(prev => ({
                ...prev, stackUserId: prev.stackUserId.slice(0, prev.stackUserId.length - 1),
                stackUserName: prev.stackUserName.slice(0, prev.stackUserName.length - 1),
                curUserId: prev.stackUserId[prev.stackUserId.length - 2]
            }))
    }
    return (
        <div >
            <div>
                <>
                    <Button onClick={() => { removeUserFromStack() }}
                        round size="tiny"
                        disabled={state.stackUserId.length == 1}
                    ><i className='icon icon-arrow-left'></i></Button>
                    <span>{state.stackUserName.join('/')}</span>
                </>

            </div>
            <div className=" common-container-col" style="overflow-y:scroll; height: 80vh;">
                <ul>
                    {state.usersList.filter((item: any) => {
                        return item.username.toLowerCase().includes(dataFilter.toLowerCase())
                            && state.curUserId != item.userId
                    }).map((data: User,index:number) => (
                        <li key={data.userId} onClick={() => {
                            if (data.userGroupRole == "user") {
                                return
                            }
                            addUserToStack(data)
                        }}>
                            <ListItem>
                                <UserItem user={data} index={index}></UserItem>
                            </ListItem>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    )
}

export default memo(AgentListEx);